<script lang="ts">
  import ResponsiveImage from '$components/blocks/marketing-sub-blocks/responsive-image.svelte';
  import ResponsiveVideo from '$components/blocks/responsive-video.svelte';
  import { cn } from '$lib/utils';

  import type { ResponsiveImageStoryblok, ResponsiveVideoStoryblok } from '$types/bloks';

  export let media: (ResponsiveImageStoryblok | ResponsiveVideoStoryblok)[];
  export let title: string | undefined = undefined;
  export let className: string | undefined = undefined;
  export { className as class };
</script>

<div
  class={cn(
    'gap-2 overflow-auto hide-scrollbar w-[calc(100%+32px)] lg:w-full flex mt-2 -ml-4',
    className
  )}
>
  {#each media as mediaItem, i}
    <div
      class={cn(
        'shrink-0 rounded-xs overflow-hidden bg-primary/8 relative',
        i === 0 && 'ml-4',
        i === media.length - 1 && 'mr-4'
      )}
    >
      {#if title && i === 0}
        <div
          class="absolute bottom-0 left-0 h-full w-full flex items-end p-2 bg-gradient-to-t to-transparent from-primary/50 via-primary/20"
        >
          <p class="text-sm font-semibold text-highlight">
            {title}
          </p>
        </div>
      {/if}
      {#if mediaItem.component == 'responsive-image'}
        <ResponsiveImage image={mediaItem} imgClass="h-[162px] w-auto" widths={[200]} />
      {:else}
        <ResponsiveVideo block={mediaItem} videoClass="object-cover h-[162px] w-auto" />
      {/if}
    </div>
  {/each}
</div>
